import { inject, Injectable } from '@angular/core';
import { CloudCompanyService } from '@core/services/cloud-company.service';
import { Observable } from 'rxjs';

@Injectable()
export class DataLoaderService {
  private cloudCompanyService: CloudCompanyService = inject(CloudCompanyService);

  loadAnnualClientData(cloudApiKey: string): Observable<string> {
    return this.cloudCompanyService.getCloudCompanyVatAccountingInterval({ cloudApiKey });
  }
}
